/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventlocationpending2Inputs */

const en_eventlocationpending2 = /** @type {(inputs: Eventlocationpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue to be announced`)
};

const de_eventlocationpending2 = /** @type {(inputs: Eventlocationpending2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort wird noch bekanntgegeben`)
};

/**
* | output |
* | --- |
* | "Venue to be announced" |
*
* @param {Eventlocationpending2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventlocationpending2 = /** @type {((inputs?: Eventlocationpending2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventlocationpending2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventlocationpending2(inputs)
	return de_eventlocationpending2(inputs)
});
export { eventlocationpending2 as "eventLocationPending" }